export default function TravelAuthorizationModel({
  travelTransHdrKey = -1,
  transDate = new Date(),
  travelAuthDate = "",
  docNum = "Auto No.",
  fromTravelDate = "",
  toTravelDate = "",
  uomKey = -1,
  uomCode = "",
  uomDesc = "",
  totalAmount = 0,
  currKey = -1,
  currCode = "",
  currDesc = "",
  exRate = 1,
  funcTotalAmount = 0,
  remarks = "",
  projKey = -1,
  projCode = "",
  projDesc = "",
  isBillable = false,
  status = 0,
  statusDesc = "",
  reason = "",
  createdBy = -1,
  createdByCode = "",
  createdDate = new Date(),
  updatedBy = -1,
  updatedByCode = "",
  updatedDate = new Date(),
  rowVersion = null,
  attaches = [],
  travelTransDet = [],
}) {
  return Object.freeze({
    TravelTransHdrKey: travelTransHdrKey,
    TransDate: transDate,
    TravelAuthDate: travelAuthDate,
    DocNum: docNum,
    FromTravelDate: fromTravelDate,
    ToTravelDate: toTravelDate,
    UOMKey: uomKey,
    UOMCode: uomCode,
    UOMDesc: uomDesc,
    TotalAmount: totalAmount,
    CurrKey: currKey,
    CurrCode: currCode,
    CurrDesc: currDesc,
    ExRate: exRate,
    FuncTotalAmount: funcTotalAmount,
    Remarks: remarks,
    ProjKey: projKey,
    ProjCode: projCode,
    ProjDesc: projDesc,
    IsBillable: isBillable,
    Status: status,
    StatusDesc: statusDesc,
    Reason: reason,
    CreatedBy: createdBy,
    CreatedByCode: createdByCode,
    CreatedDate: createdDate,
    UpdatedBy: updatedBy,
    UpdatedByCode: updatedByCode,
    UpdatedDate: updatedDate,
    RowVersion: rowVersion,
    Attaches: attaches,
    TravelTransDet: travelTransDet,
  });
}
